import { ProductSupplierModelType } from '@teinor/erp/types/company/product/productSupplier'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router'
import ModalCreateEdit from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { FormRender } from '../../../../../../forms/FormRenderer/types'
import { twinFetchPostJSON } from '../../../../../../utils/globals/data'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { getISOCurrencyMain } from '../../../../../../utils/reducers/getters'
import withLoading from '../../../../../../utils/hoc/withLoading'
import { connect, ConnectedProps } from 'react-redux'
import { AllReduxPayloads } from '../../../../../../utils/reducers'
import { SupplierPayload } from '../../../../../../utils/reducers/products/suppliers'

type ModalCreateProductSupplierProps = ModalEditComponentProps & ReduxModalCreateProductSupplierConnector & {}

const ModalCreateProductSupplier: React.FC<ModalCreateProductSupplierProps> = ({ userPermissions, allRowData, suppliers, ...rest }) => {
    const { t } = useTwinTranslation()
    const { suppliersDict, id, selectedSuppliers, itemsTypeDiscount } = useModalCreateProductSupplierLogic({ suppliers })
    const mainCurrency = getISOCurrencyMain()
    const fields: FormRender<ProductSupplierModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'SupplierId',
                    label: t('supplier', 'Proveedor'),
                    component: 'CustomSelectSearchBarWithNotInFilteredItems',
                    items: suppliersDict,
                    excludeItems: selectedSuppliers,
                    value: '',
                    required: true,
                },
                {
                    name: 'supplier_reference',
                    label: t('supplierReference', 'Referencia del proveedor'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'delivery_time',
                    label: t('deliveryTime', 'Tiempo de entrega'),
                    component: 'InputWithLabelMargin',
                    type: 'text'
                },
                {
                    name: 'last_price',
                    label: t('lastPrice', 'Último precio'),
                    component: 'InputCurrencyStateFull',
                    defaultValue: { price: allRowData?.last_price, CurrencyId: allRowData?.CurrencyId || mainCurrency },
                    nameExtended: { price: 'last_price', CurrencyId: 'CurrencyId' }
                },
                {
                    name: 'last_discount',
                    label: t('lastDiscount', 'Último descuento'),
                    component: 'InputWithLabelMargin',
                },
                {
                    name: 'last_type_discount',
                    label: t('typeDiscount', 'Tipo descuento'),
                    component: 'CustomSelect',
                    items: itemsTypeDiscount
                },
                {
                    name: 'default_supplier',
                    label: t('defaultSupplier', 'Proveedor por defecto'),
                    component: 'CheckboxMargin',
                },
                {
                    name: 'ProductId',
                    component: 'InputHidden',
                    value: id
                }
            ],
        },
    ]

    return (<ModalCreateEdit fields={fields} url={'/api/app/product/productSupplier/createProductSupplier'} translations={{
        title: t('createSupplier', 'Crear proveedor'),
        button: t('create', 'Crear')
    }} haveButtonPermissions={true} {...rest} />)
}
interface ModalCreateProductSupplierLogicProps {
    suppliers: SupplierPayload
}
const useModalCreateProductSupplierLogic = ({ suppliers }: ModalCreateProductSupplierLogicProps) => {
    const [selectedSuppliers, setSelectedSuppliers] = useState<string[]>([])
    const suppliersDict = useMemo(() => suppliers?.all|| {}, [suppliers?.all])

    const { id } = useParams()
    const { t } = useTwinTranslation()
    const itemsTypeDiscount: TwinDictionary = { 0: { name: t('percentage', 'Porcentaje') }, 1: { name: t('amountTotal', 'Importe total') }, 2: { name: t('amountUnit', 'Importe por unidad') } }
    const getSelectedSuppliers = useCallback(async () => {
        const result = await twinFetchPostJSON('/api/app/product/productSupplier/getAllProductSuppliers', { where: { ProductId: id } })
        const selected: string[] = []
        for (const selectedSupplier of result) {
            selected.push(String(selectedSupplier.SupplierId))
        }
        setSelectedSuppliers(selected)
    }, [setSelectedSuppliers, id])

    useEffect(() => {
        getSelectedSuppliers()
    }, [getSelectedSuppliers])

    return { suppliersDict, id, selectedSuppliers, itemsTypeDiscount }
}

const modalCreateProductSupplierDispatch = {
    setSuppliers: (payload: SupplierPayload) => ({ type: 'CHANGE_SUPPLIER', payload }),
}
const mapModalCreateProductSupplierConnector = (state: AllReduxPayloads) => ({ suppliers: state.suppliers })
const modalCreateProductSupplierConnector = connect(mapModalCreateProductSupplierConnector, modalCreateProductSupplierDispatch)
type ReduxModalCreateProductSupplierConnector = ConnectedProps<typeof modalCreateProductSupplierConnector>

const modalCreateProductSupplierConnectLoading = withLoading(ModalCreateProductSupplier, [{ fetchUrl: '/api/app/supplier/getAllSuppliersComplete', propName: 'suppliers', setFunctionName: 'setSuppliers' }])

const ModalCreateProductSupplierConnect = modalCreateProductSupplierConnector(modalCreateProductSupplierConnectLoading)

export default ModalCreateProductSupplierConnect;